import { useUserContext } from "@/features/user/contexts/useUserContext";
import { PostDetailFragment, PostTypeEnum } from "@/generated/generated-hooks";

import { PostCarousel } from "./PostCarousel";
import { PostVideoDisplay } from "./PostVideoDisplay";

export function PostMedia({ post }: { post: PostDetailFragment }) {
  const { user } = useUserContext();

  const { writer, postBlurLevel, userBlurLevel } = post;
  const isOwner = writer._id === user?._id;

  if (post.postType === PostTypeEnum.Video) {
    return <PostVideoDisplay isOwner={isOwner} postDetail={post} />;
  }

  return (
    <PostCarousel
      postBlurLevel={postBlurLevel}
      userBlurLevel={userBlurLevel}
      isOwner={isOwner}
      postDetail={post}
    />
  );
}
